<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <advanced-vehicle-sub-menu
        @clear="$emit('clear-filter')"
        class="sticky-fully"
      >
        <template #filter>
          <q-btn
            class="cursor-pointer q-ml-sm text-white bg-primary"
            @click="$emit('vehicle-search')"
            label="Filter"
          />
        </template>
        <template #activator>
          <div class="row-end" v-if="$route.name === 'vehicle-advanced' ||
          ($route.name === 'for-sale' && forSaleRoute === routes.vehicleList) ||
          ($route.name === 'blackbook' && blackbookRoute === routes.vehicleList)">
            <q-btn outline color="primary" label="Advanced Filters" @click="activate = true"></q-btn>
            <q-toggle toggle-indeterminate v-model="manuallyPriced">
              <q-tooltip>
                <span v-if="manuallyPriced === null"> Switch to show only manually priced </span>
                <span v-if="manuallyPriced === true"> Toggle to show only those that are not manually priced </span>
                <span v-if="manuallyPriced === false"> Switch to all </span>
              </q-tooltip>
            </q-toggle>
            <div style="display:flex;align-items:center;position:relative">
              <q-btn @click="show = !show" round color="grey-7" size="sm" style="margin-left:5px">
                <q-icon name="fas fa-caret-down"></q-icon>
              </q-btn>
              <q-list
                v-if="show"
                bordered
                dense
                class="bg-grey-1"
                style="position:absolute;width:200px;left:-150px;top:40px;z-index:100;height:400px;overflow-y:auto"
              >
                <q-item
                  active-class="text-primary"
                  clickable
                  v-ripple
                  v-for="(col, index) in columns"
                  :key="index"
                  :active="itemIsVisible(col)"
                  @click="toggleColumn(col)"
                >
                  <q-item-label class="q-py-sm q-ma-none">{{
                    col.name
                  }}</q-item-label>
                </q-item>
              </q-list>
              <div class="row-end" style="margin-left:5px">
                <q-btn
                  round
                  @click="$store.commit('profit/SET_TAG_OPERATION', true)"
                  color="primary"
                  size="sm"
                  :disable="isDisable || $store.state.tag.tags.length === 0"
                >
                  <q-icon name="fas fa-tags"></q-icon>
                </q-btn>
              </div>
            </div>
          </div>
          <div class="row-end" v-if="$route.name === 'for-sale' && forSaleRoute === routes.selectionList">
            <div style="display:flex;align-items:center;position:relative">
              <q-btn @click="showForSaleSelectionList = !showForSaleSelectionList" round color="grey-7" size="sm" style="margin-left:5px">
                <q-icon name="fas fa-caret-down"></q-icon>
              </q-btn>
              <q-list
                v-if="showForSaleSelectionList"
                bordered
                dense
                class="bg-grey-1"
                style="position:absolute;width:200px;left:-150px;top:40px;z-index:100;height:400px;overflow-y:auto"
              >
                <q-item
                  active-class="text-primary"
                  clickable
                  v-ripple
                  v-for="(col, index) in forSaleSelectionListColumns"
                  :key="index"
                  :active="col.visible"
                  @click="toggleForSaleSelectionListColumns(col)"
                >
                  <q-item-label class="q-py-sm q-ma-none">{{ col.name.toUpperCase() }}</q-item-label>
                </q-item>
              </q-list>
            </div>
          </div>
          <div class="row-end" v-if="$route.name === 'blackbook' && blackbookRoute === routes.selectionList">
            <div style="display:flex;align-items:center;position:relative">
              <q-btn @click="showBlackbookSelectionList = !showBlackbookSelectionList" round color="grey-7" size="sm" style="margin-left:5px">
                <q-icon name="fas fa-caret-down"></q-icon>
              </q-btn>
              <q-list
                v-if="showBlackbookSelectionList"
                bordered
                dense
                class="bg-grey-1"
                style="position:absolute;width:200px;left:-150px;top:40px;z-index:100;height:400px;overflow-y:auto"
              >
                <q-item
                  active-class="text-primary"
                  clickable
                  v-ripple
                  v-for="(col, index) in blackbookSelectionListColumns"
                  :key="index"
                  :active="col.visible"
                  @click="toggleBlackbookSelectionListColumns(col)"
                >
                  <q-item-label class="q-py-sm q-ma-none">{{ col.name.toUpperCase() }}</q-item-label>
                </q-item>
              </q-list>
            </div>
          </div>
        </template>
      </advanced-vehicle-sub-menu>
    </div>
  </q-card>
</template>

<script>
import AdvancedVehicleSubMenu from "./AdvancedVehicleSubMenu";
import axios from "../axios/";
import {routes} from "@/components/forSale/routes";
export default {
  components: { AdvancedVehicleSubMenu },
  mounted() {
    this.$root.$on("clearSelectedVehicle", (i) => {
      i.length > 0 ? (this.isDisable = false) : (this.isDisable = true);
    });
  },
  data() {
    return {
      show: false,
      showForSaleSelectionList: false,
      showBlackbookSelectionList: false,
      isDisable: true,
      columns: [
        {
          name: "SELECT",
          val: "selection",
        },
        {
          name: "Unit",
          val: "unit",
        },
        {
          name: "Location",
          val: "location",
        },
        {
          name: "Company",
          val: "company",
        },
        {
          name: "Vehicle Class",
          val: "class_name",
        },
        {
          name: "VIN",
          val: "vin",
        },
        {
          name: "Model Year",
          val: "model_year",
        },
        {
          name: "Make",
          val: "brand",
        },
        {
          name: "Model",
          val: "model",
        },
        {
          name: "Model Detail",
          val: "model_detail",
        },
        {
          name: "In Service Date",
          val: "in_service_date",
        },
        {
          name: 'Months in Service',
          val: 'months_in_service'
        },
        {
          name: "Mileage",
          val: "mileage",
        },
        {
          name: 'AVG CR',
          val: 'condition_grade'
        },
        {
          name: "Condition",
          val: "condition",
        },
        {
          name: "Manheim Auction Value",
          val: "mmr",
        },
        {
          name: "Blackbook Auction Value",
          val: "blackbook_auction",
        },
        {
          name: "Manheim Auction Weekly Change",
          val: "auction_weekly_change",
        },
        {
          name: "Estimated Payoff",
          val: "payoff",
        },
        {
          name: "Estimated Revenue/Loss",
          val: "revenue",
        },
        {
          name: "Estimated Cap Cost",
          val: "estimated_cap_cost",
        },
        {
          name: "Monthly Payment",
          val: "monthly_payment",
        },
        {
          name: "Remaning Months",
          val: "aging",
        },
        {
          name: "Finance",
          val: "source",
          sub: "Finance",
        },
        {
          name: "Custom Tag",
          val: "tags",
        },
      ],
      subMenu: false,
    };
  },
  computed: {
    routes() {
      return routes
    },
    takeReport() {
      return this.$store.state.profile?.user?.is_history_reports || false;
    },
    financial: {
      get() {
        return this.$store.state.profit.financial;
      },
      set(val) {
        this.$store.commit("profit/SET_FINANCIAL", val);
      },
    },
    manuallyPriced: {
      get() {
        return this.$store.state.profit.manuallyPriced;
      },
      set(val) {
        this.$store.commit("profit/SET_MANUALLY_PRICED", val);
      },
    },
    visibleColumns: {
      get() {
        return this.$store.state.profit.visibleColumns;
      },
      set(val) {
        this.$store.commit("profit/SET_VISIBLE_COLUMNS", val);
      },
    },
    forSaleSelectionListColumns: {
      get() {
        return this.$store.state.forSale.selectionListColumns;
      },
      set(val) {
        this.$store.commit("forSale/SET_SELECTION_LIST_COLUMNS", val);
      },
    },
    blackbookSelectionListColumns: {
      get() {
        return this.$store.state.blackbook.selectionListColumns;
      },
      set(val) {
        this.$store.commit("blackbook/SET_SELECTION_LIST_COLUMNS", val);
      },
    },
    activate: {
      get() {
        return this.$store.state.profit.activate;
      },
      set(val) {
        this.$store.commit("profit/SET_ACTIVATE_MODAL", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.profit.loading;
      },
      set(val) {
        this.$store.commit("profit/SET_LOADING", val);
      },
    },
    companies: {
      get() {
        return this.$store.state.profit.companies;
      },
      set(val) {
        this.$store.commit("profit/SET_COMPANIES", val);
      },
    },
    company: {
      get() {
        return this.$store.state.profit.company;
      },
      set(val) {
        this.$store.commit("profit/SET_COMPANY", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.profit.locations;
      },
      set(val) {
        return this.$store.commit("profit/SET_LOCATIONS", val);
      },
    },
    forSaleRoute: {
      get() {
        return this.$store.state.forSale.route;
      },
      set(val) {
        this.$store.commit("forSale/SET_ROUTE", val);
      },
    },
    blackbookRoute: {
      get() {
        return this.$store.state.blackbook.route;
      },
      set(val) {
        this.$store.commit("blackbook/SET_ROUTE", val);
      },
    },
  },
  methods: {
    itemIsVisible(col) {
      return this.visibleColumns.some((item) => item.name === col.name);
    },
    toggleColumn(col) {
      if (this.itemIsVisible(col)) {
        this.visibleColumns = this.visibleColumns.filter(
          (item) => item.name !== col.name
        );
      } else {
        this.visibleColumns.push(col);
      }
    },
    toggleForSaleSelectionListColumns(col) {
      this.forSaleSelectionListColumns.forEach(item => {
        if (item.name === col.name) {
          item.visible = !item.visible;
        }
        return item;
      });
    },
    toggleBlackbookSelectionListColumns(col) {
      this.blackbookSelectionListColumns.forEach(item => {
        if (item.name === col.name) {
          item.visible = !item.visible;
        }
        return item;
      });
    },
  },
  watch: {
    forSaleRoute: {
      handler(val) {
        this.show = false;
        this.showForSaleSelectionList = false;
      },
    },
    blackbookRoute: {
      handler(val) {
        this.show = false;
        this.showBlackbookSelectionList = false;
      },
    },
  }
};
</script>

<style lang="scss">
.row-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}
.sticky-fully {
  margin: 0 18px 0 22px;
  display: flex;
  flex-flow: row nowrap;
  flex: 1;
  .sticky-select {
    flex: 0 1 20%;
  }
  .sticky-location {
    margin-left: 10px;
    flex: 0 1 20%;
  }
}
</style>
